import Footer from "./Footer";
import {Link} from "react-router";
import {Container} from "react-bootstrap";

const APK_LINK = "https://socpracvmobilu.cz/public/spm-mobile-1.9.6.apk";

export default function HomePage() {
	return (
		<Container>
			<h1 className="py-4">Sociální pracovník v mobilu</h1>
			<p>
				<strong>CO TO JE?</strong> Mobilní aplikace, která umožňuje snadno najít konkrétní kontakt či informaci při řešení nepříznivých
				sociálních situací. Informace jsou průběžně doplňovány a aktualizovány.
			</p>
			<p>
				<strong>PRO KOHO JE?</strong> Pro sociální pracovníky, státní úředníky a další pomáhající profesionály i laiky, kteří chtějí vyhledat
				pomoc pro druhou osobu.
			</p>
			<p>
				<strong>JAK TO FUNGUJE?</strong> Aplikace je určena pro telefony s operačním systémem Android a je volně ke stažení:
			</p>
			<p>
				<a
					target="_blank"
					href={APK_LINK}
					className="btn btn-success btn-lg"
				>
					Stáhnout
				</a>
			</p>
			<p>
				Aplikaci nyní aktualizujeme, její fungování by to však nemělo omezit.
				Uvítáme jakékoliv podněty pro zlepšení. Přidejte se k nám na Facebooku, nebo nám napište email na adresu <a
				href="mailto:info@socpracvmobilu.cz">info@socpracvmobilu.cz</a>.
			</p>
			<p>
				Před stažením si prosím přečtěte <Link to="/podminky">podmínky užití</Link>.
			</p>
			<p>
				Budeme rádi, pokud zprávu o aplikaci rozšíříte dál. Můžete využít náš <a href="/spm-plakat-cs.pdf">plakát</a> a vylepit jej u vás na
				pracovišti, aby jej viděli vaši klienti.
			</p>
			<br/>
			<br/>
			<h2><img height="75" style={{float: 'left'}} src="/uk-flag.png"/>Соціальний працівник у смартфоні Початкова соціальна консультація для
				українців в Чехії</h2>
			<p>
				<strong>Що це?</strong> Мобільний застосунок, який допомагає легко знайти конкретний контакт чи інформацію для вирішення скрутних
				життєвих ситуацій спеціально для вимушених переселенців з України.
			</p>
			<p>
				<strong>Для кого це?</strong> Для приїжджих з України, для професіоналів, чи ні, які хочуть допомогти і які потребують певної допомоги
				в певному місці.
			</p>
			<p>
				<strong>Як це працює?</strong> Застосунок створений для смартфонів на базі Андроїд і є доступний для безкоштовного:
			</p>

			<p>
				<a
					target="_blank"
					href={APK_LINK}
					className="btn btn-success btn-lg"
				>
					Завантажити
				</a>
			</p>
			<p>
				<Link to="/podminky">Умови використання</Link>
			</p>
			<Footer/>
		</Container>
	);
};
